var req = require("!!/opt/build/repo/node_modules/pug-loader/index.js!/opt/build/repo/src/app/ehs/views/login-page/login-page.component.pug");
module.exports = (req['default'] || req).apply(req, [])